<template>
  <!-- 供應商的貨物狀態查詢:跟客戶同一頁,供應商欄換成每箱的客戶 -->
  <CustomerContainerBoxList supplier-view></CustomerContainerBoxList>
</template>
<script>
import CustomerContainerBoxList from "./CustomerContainerBoxList";
export default {
  components: { CustomerContainerBoxList },
};
</script>
